import styles from '../Components/styles/InventoryOverviewPopup.module.scss';
import Risk from '../../../../Inventory/InventoryDetails/Risk';

type Props = {
  description: string;
  envRisk: any;
  color: string;
  chemRiskLevel: any;
};

const RiskRow = ({ description, envRisk, color, chemRiskLevel }: Props) => {
  return (
    <div>
      <Risk
        id="envRisk"
        label={'environmental.risk.label.with.value'}
        value={description}
        value2={envRisk}
        levelColor={color}
        display
        tooltip={'environmental.risk.tooltip'}
      />

      <Risk
        id="chemRisk"
        label={'chemical.risk.label.with.value'}
        value={chemRiskLevel?.id}
        levelColor={chemRiskLevel?.color}
        display
        tooltip={'chemical.risk.tooltip'}
      />
    </div>
  );
};

export default RiskRow;
